<template>
  <div>
    <div id="map" ></div>
  </div>
</template>

<script>
import Utils from "./../lib/Utils";
export default {
  name: "GeoMap",
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
      return {
          marker: null,
          lastLat: 0,
          lastLng: 0
      }
  },
  methods: {
    load_map_location() {
      //https://medium.com/@javajoint/how-to-map-cities-with-vue-geojson-and-google-part-1-617d3eb796e0
      //https://www.npmjs.com/package/vue-plugin-load-script
      this.$loadScript(
        "https://maps.googleapis.com/maps/api/js?key=" +
          Utils.google_maps_api_key
      )
        .then(() => {
          // Script is loaded, do something
          console.log("Map is loaded fine: ");
          this.init_map();
        })
        .catch((errors) => {
          // Failed to fetch script
          console.log("Failed to load the map on business view: ", errors);
        });
    },
    update_maker(latlng){
        if(!this.marker || this.marker == null){
            this.marker = new google.maps.Marker({
                map: this.map
            })
        }
        this.marker.setPosition(latlng);
        this.$emit("on-set-location",{lat:this.lastLat, lng: this.lastLng});
    },
    init_map() {
      var latitude = parseFloat(this.business.lat);
      var longitude = parseFloat(this.business.lng);
      var config = {
        center: { lat: latitude, lng: longitude },
        zoom: 15,
      };
      if(this.is_editing){
          config["gestureHandling"] = "greedy";
      }
      this.map = new google.maps.Map(document.getElementById("map"), config);
      if(this.is_editing){
          google.maps.event.addListener(this.map,"click", (event) => {
              this.lastLat = event.latLng.lat();
              this.lastLng = event.latLng.lng();
              this.update_maker(event.latLng);
          });
      }
    },
  },
  mounted() {
    this.load_map_location();
  }
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 400px;
}
</style>